<template>
  <div class="serviceProviderManage">
    <div class="whole_company_from">
      <el-form ref="searchForm" :model="searchForm">
        <QS-search maxLine="2" ref="BLM-search">
          <!-- 内容区域-->
          <el-form-item prop="name" label="服务商名称">
            <el-select
              v-model="searchForm.name"
              filterable
              clearable
              placeholder="请输入关键词"
              :loading="loading"
            >
              <el-option
                v-for="item in providerData"
                :key="item.id"
                :label="`${item.name} ${item.contactTel}`"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="serviceType" label="服务商类型">
            <el-select
              v-model="searchForm.serviceType"
              placeholder="请选择"
              clearable
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in typeList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="contacts" label="联系人">
            <el-input
              v-model="searchForm.contacts"
              v-delete-emoji
              placeholder="请输入联系人"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="contactTel" label="联系方式">
            <el-input
              v-model="searchForm.contactTel"
              v-delete-emoji
              placeholder="请输入联系方式"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="id" label="服务商ID">
            <el-input
              v-model="searchForm.id"
              placeholder="请输入服务商ID"
              clearable
              v-number:integer="18"
            ></el-input>
          </el-form-item>
         <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
          <template slot="moreBtn">
            <div class="moreBtn-wrapper">
              <el-form-item>
                <el-button
                  type="primary"
                  size="small"
                  @click="search"
                  :loading="searchLoading"
                  >查询</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button @click="reset" size="small">重置</el-button>
              </el-form-item>
            </div>
          </template>
          <!-- -->
        </QS-search>
      </el-form>
    </div>
    <el-button
      @click="addServiceBtn"
      type="primary"
      size="small"
      v-if="judgePermission('purchase_new_provider_list_create')"
    >
      新增服务商
    </el-button>
    <div>
      <QS-common-table
        :data="tableData"
        :columns="serverProviderManageColumns"
        row-key="id"
        :pagination="paginationData"
        @change="paginationChange"
    />

      <!------服务商详情------>
      <dialogWrap
        :dialogShow="detailServiceDialog.show"
        :title="detailServiceDialog.title"

        @change="detailShow"
        :hasFooter="false"
        :width="'824px'"
      >
        <ServierDetail
          :addEditFormData.sync="addEditFormData"
          v-if="detailServiceDialog.show"
        ></ServierDetail>
      </dialogWrap>
      <!------启用/禁用弹框------>
      <dialogWrap v-model="oShow.startStop" title="提示" :width="'400px'">
        {{ startStoTitle }}
        <template slot="footer">
          <el-button @click="cancelFn">取消</el-button>
          <el-button
            @click="submitUpdateHandle(1)"
            v-if="startStoType === 'enable'"
            type="primary"
            size="small"
            :loading="btnEnableLoading"
          >
            启用
          </el-button>
          <el-button
            @click="submitUpdateHandle(0)"
            v-if="startStoType === 'disable'"
            type="primary"
            size="small"
            :loading="btnEnableLoading"
          >
            禁用
          </el-button>
        </template>
      </dialogWrap>
      <!-- 新增编辑服务商 -->
      <HandleProvider
        ref="HandleProvider"
        :type="handleType"
        :editData="editData"
        @handleSuccess="search"/>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { providerList, providerUpdateState } from '@/api/domain/carsService'
import SelectOption from '@/store/dict/selectOptionDict'
import HandleProvider from '../components/handleProvider.vue'
import ServierDetail from '../components/servierDetail.vue'
import config from '../config'

export default {
  name: 'serviceProviderManage',
  components: {
    ServierDetail,
    HandleProvider,
  },
  data() {
    const { serverProviderManageColumns } = config.call(this)
    return {
      editData: null,
      handleType: 'add', // 编辑，新增服务商
      loading: false,
      BLMloading: false,
      providerData: [],
      // eslint-disable-next-line vue/no-unused-properties
      accountStateDict: SelectOption.accountStateDict, // serverProviderManageColumns 有引用
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      oShow: {
        startStop: false,
      },
      searchForm: {
        id: '',
        name: '',
        serviceType: '',
        contacts: '',
        contactTel: '',
      },
      addEditFormData: {
        id: '',
        name: '',
        serviceType: '',
        contacts: '',
        contactTel: '',
        expireDate: '',
        companyName: '',
        creditCode: '',
        legalPersonName: '',
        address: '',
        remarks: '',
        // 开户账号
        accountNo: '',
        // 账户名称
        accountName: '',
        // 营业执照url
        businessLicenceUrl: [],
        // 法人身份证号码
        idCardNo: '',
        // 开户银行名称
        bankName: '',
        // 税票类型
        taxType: '',
        // 税号
        taxNo: '',
      },
      startStoTitle: '是否启用该服务商？',
      startStoType: 'enable',
      tableData: [],
      detailServiceDialog: {
        show: false,
        title: '服务商详情',
      },
      serverProviderManageColumns,
      stateObj: {
        id: '',
        state: '',
      },
      // 启用禁用弹框确定按钮loading
      btnEnableLoading: false,
      // 查询按钮loading
      searchLoading: false,
    }
  },
  methods: {
    async loadData() {
      this.BLMloading = true
      const { code, data } = await providerList({
        ...this.$route.query,
        ...this.searchForm,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      })
      if (code === 1) {
        this.searchLoading = false
        this.paginationData.total = data.totalNum
        this.tableData = data.items
        this.BLMloading = false
      } else {
        this.searchLoading = false
      }
    },
    search() {
      this.paginationData.pageNum = 1
      this.searchLoading = true
      this.loadData()
    },
    reset() {
      this.$refs.searchForm.resetFields()
      Object.keys(this.searchForm).forEach((item) => {
        this.searchForm[item] = ''
      })
      this.search()
    },
    // 列表编辑 serverProviderManageColumns 有引用
    // eslint-disable-next-line vue/no-unused-properties
    async editHandle(row) {
      this.editData = row
      this.handleType = 'edit'
      this.$refs.HandleProvider.handelDialogVisible = true
    },
    // 新增
    addServiceBtn() {
      this.editData = {}
      this.handleType = 'add'
      this.$refs.HandleProvider.handelDialogVisible = true
    },
    // 详情，serverProviderManageColumns有引用
    // eslint-disable-next-line vue/no-unused-properties
    detailDialog(row) {
      this.addEditFormData = row
      this.detailServiceDialog.show = true
    },
    // 启用禁用，serverProviderManageColumns有引用
    // eslint-disable-next-line vue/no-unused-properties
    startStopHandle(type, row) {
      if (type === 'enable') {
        this.startStoTitle = '是否启用该服务商？'
        this.startStoType = 'enable'
        this.stateObj = {
          id: row.id, // 服务商id
          state: 1, // 服务商状态 0启用 1禁用
        }
      }
      if (type === 'disable') {
        this.startStoTitle = '是否禁用该服务商？'
        this.startStoType = 'disable'
        this.stateObj = {
          id: row.id, // 服务商id
          state: 0, // 服务商状态 0启用 1禁用
        }
      }
      this.oShow.startStop = true
    },
    paginationChange(payload) {
      const { pagination: { pageSize, pageNum } } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.loadData()
    },
    cancelFn() {
      this.oShow.startStop = false
    },
    detailShow(bol) {
      this.detailServiceDialog.show = bol
    },
    submitUpdateHandle() {
      this.btnEnableLoading = true
      providerUpdateState(this.stateObj)
        .then(() => {
          this.btnEnableLoading = false
          this.loadData()
          this.cancelFn()
        })
        .catch((error) => {
          this.btnEnableLoading = false
          this.$message.error(error)
        })
    },
    async loadProviderData() {
      this.providerData = []
      this.loading = true
      providerList().then(({ code, data }) => {
        if (code === 1) {
          this.providerData = data.items
        }
      })
        .finally(() => {
          this.loading = false
        })
    },
    handlePopState() {
      // 关闭弹窗
      if (this.$refs.HandleProvider && this.$refs.HandleProvider.handelDialogVisible) {
        this.$refs.HandleProvider.closeDialog()
      }
    },
  },
  computed: {
    // 服务商类型
    typeList() {
      return this.dictParseList(SelectOption.serviceProviderTypeDict)
    },
  },
  mounted() {
    this.loadData()
    this.$refs['BLM-search'].searchMoreClick()
    window.addEventListener('popstate', this.handlePopState)
  },
  created() {
    this.loadProviderData()
    if (this.$route.query.serviceId) {
      this.searchForm.id = this.$route.query.serviceId
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState)
  },
}
</script>

<style lang='scss' scoped>
::v-deep .el-table__body-wrapper .el-table_1_column_1 {
  color: #0059dc;
  font-weight: 400;
  cursor: pointer;
}
.addEditFormData {
  ::v-deep .el-input--small {
    width: 200px;
  }
}
.customer{
  display: flex;
  flex-direction: row;
  &-name{
    width: 100px;
    height: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-phone{
    color: #8492a6;
    font-size: 13px;
    padding-left: 20px;
  }
}

</style>
